import type { EndorsementSummaryTemplatesResponse } from '@domain/schemas/endorsement-summary-templates.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import { queryOptions, useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const fetchEndorsementSummaryTemplates = async (): Promise<EndorsementSummaryTemplatesResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: '/endorsement-summary-templates',
  });

  const { data } = await axios<EndorsementSummaryTemplatesResponse>(networkPayload);

  return data;
};

export const endorsementSummaryTemplateQueries = {
  all: () =>
    queryOptions({
      queryKey: ['endorsement-summary-templates'] as const,
      queryFn: fetchEndorsementSummaryTemplates,
      staleTime: 300_000,
    }),
};

export function useEndorsementSummaryTemplates(enabled: boolean) {
  return useQuery({ ...endorsementSummaryTemplateQueries.all(), enabled });
}
